import GlowBar from 'components/GlowBar';
import MainLayout from 'components/layout/MainLayout';
import PageTitle from 'components/PageTitle';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import css from 'styled-jsx/css';

const TermsAndConditions = () => {
  return (
    <MainLayout>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
      <NextSeo
        title="Terms & Conditions | Win Epic Prizes | DAYMADE"
        openGraph={{
          title: 'Terms & Conditions | Win Epic Prizes | DAYMADE',
        }}
      />

      <PageTitle>
        Terms & <strong>Conditions</strong>
      </PageTitle>

      <div className="paddedMaxWidthContainer" style={{ padding: '2em' }}>
        <div className="container">
          <h2>INTRODUCTION</h2>
          <p>
            DAYMADE is an associated brand of, and operated by, DAYMADE LTD
            (registered in England & Wales, company number 12333770).
          </p>
          <p>
            Please read these terms and conditions (Terms) carefully as it is a
            legally binding contract.
          </p>
          <p>
            These Terms set out the terms and conditions under which DAYMADE
            (DAYMADE, we, or us) provides you access to, and governs your use
            of, the website located at www.daymade.co.uk and the information,
            content, features and services provided through the Site.
          </p>
          <p>
            Your use of the Site, or by clicking "I accept" (or equivalent
            phrase) if presented with these Terms in a click-through format,
            signifies and constitutes your binding acceptance of these Terms,
            including any modifications that DAYMADE makes from time to time. If
            you do not accept, you may not use the site or the Service.
          </p>
          <p>
            You may not use the Site and you may not accept these Terms if you
            are not at least 18 years old and resident in the United Kingdom. If
            you accept these Terms, you represent that you have the legal
            capacity to be bound by it. DAYMADE may amend these Terms at any
            time by posting the amended terms and conditions on the Site, and
            you agree that you will be bound by any updated terms. The date of
            last revision of these Terms was 29th July 2022. DAYMADE may make
            changes to the Site at any time. You understand that DAYMADE may
            discontinue or restrict your use of the Site for any reason with or
            without notice.
          </p>

          <h2>Contents</h2>
          <ol>
            <li>DEFINED TERMS</li>
            <li>OUR STATUS</li>
            <li>PRIVACY POLICY</li>
            <li>THE SITE</li>
            <li>PURCHASING ENTRIES</li>
            <li>REFERRAL ENTRIES</li>
            <li>ENTRIES AWARDED AS PRIZES</li>
            <li>SUBSCRIPTION ENTRIES</li>
            <li>SUBSCRIPTION CANCELLATIONS</li>
            <li>REFUNDS</li>
            <li>INTERNET ACCESS</li>
            <li>ACCOUNTS</li>
            <li>TERMINATION OF ACCOUNT</li>
            <li>POLICY FOR VULNERABLE PLAYERS</li>
            <li>LIMITED LICENCE TO USE SITE AND SERVICE</li>
            <li>USE OF SITE AND SERVICE</li>
            <li>THIRD PARTY PRODUCTS</li>
            <li>HYPERLINKS</li>
            <li>INTELLECTUAL PROPERTY</li>
            <li>DISCLAIMER OF WARRANTIES</li>
            <li>LIMITATION OF LIABILITY</li>
            <li>INDEMNIFICATION</li>
            <li>ANTI MONEY LAUNDERING POLICY</li>
            <li>GOVERNING LAW AND JURISDICTION</li>
            <li>GENERAL</li>
            <li>PRIZE DRAW RULES</li>
            <li>PAYMENT OF PRIZES</li>
            <li>TAXATION OF PRIZES</li>
            <li>DISPUTES</li>
            <li>GIFT CARDS</li>
            <li>DAYMADE TOKENS</li>
            <li>CHARITY</li>
            <li>PROMOTIONAL REWARDS</li>
          </ol>

          <h3>1. DEFINED Terms</h3>

          <table cellSpacing="0" cellPadding="0" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Term</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Account</td>
                <td>
                  Customer profile on the Site in accordance with section 12.
                </td>
              </tr>
              <tr>
                <td>Closing Date</td>
                <td>
                  The date and time that a specific draw locks and no further
                  entries will be accepted.
                </td>
              </tr>
              <tr>
                <td>Customer</td>
                <td>
                  an individual registered with a valid DAYMADE account that
                  enters a Prize Draw through purchase of an entry or by a Free
                  Alternative Method of Entry.
                </td>
              </tr>
              <tr>
                <td>Draw Date</td>
                <td>
                  this indicates the date and time the draw will be performed.
                  This date is always clearly highlighted on the enter page for
                  each specific draw that has a draw date.
                </td>
              </tr>
              <tr>
                <td>Entrant</td>
                <td>A customer who has entered a specific draw.</td>
              </tr>
              <tr>
                <td>Free Alternative Method of Entry</td>
                <td>
                  a way to enter any of our draws or raffles without having to
                  purchase a ticket. each individual who is eligible to
                  participate has a choice whether to do so by paying or by
                  sending a communication via the post. Such entries are treated
                  exactly the same as paid entries with the same chances of
                  winning and same selection of prizes.
                </td>
              </tr>
              <tr>
                <td>Service</td>
                <td>
                  the services to be provided, or which are provided, by daymade
                </td>
              </tr>
              <tr>
                <td>Site</td>
                <td>DAYMADE’s website at www.daymade.co.uk</td>
              </tr>
              <tr>
                <td>Token</td>
                <td>
                  a DAYMADE credit that can be purchased on the Site or won
                  through our prize draws, which can only be redeemed within
                  DAYMADE and cannot be withdrawn or exchanged for cash. Tokens
                  are auto-redeemed for trees 12 months after winning your most
                  recent token.
                </td>
              </tr>
              <tr>
                <td>Subscriber</td>
                <td>
                  an individual registered with a valid DAYMADE account that
                  opts into (a) weekly draw(s).
                </td>
              </tr>
              <tr>
                <td>Prizes</td>
                <td>
                  refers to the good or service so specified in each competition
                  that a winner or runner up of that competition may receive
                </td>
              </tr>
              <tr>
                <td>Prize Draws</td>
                <td>
                  any prize draw or competition organised by DAYMADE in
                  accordance with section 24 of these Terms.
                </td>
              </tr>
              <tr>
                <td>Prize Draw Rules</td>
                <td>the rules of the Prize Draws as set out in section 24.</td>
              </tr>
              <tr>
                <td>Privacy Policy</td>
                <td>the data privacy policy available to Users on the Site.</td>
              </tr>
              <tr>
                <td>Users</td>
                <td>
                  an individual registered with a valid DAYMADE account that
                  uses the Services on the Site
                </td>
              </tr>
            </tbody>
          </table>

          <h3>2. OUR STATUS</h3>
          <p>We do not promote a lottery and are not lottery promoters.</p>
          <p>
            We are not a gambling or gaming company requiring a license from the
            UK Gambling Commission.
          </p>
          <p>
            DAYMADE operates and makes entry available into regular Prize Draws.
            The way in which DAYMADE operates these Prize Draws falls outside
            the definition of gambling as set out in Section 3 of the Gambling
            Act 2005. Therefore, it does not require a licence to operate and
            does not constitute gambling.
          </p>
          <p>
            It does this by providing Free Alternative Method of Entry into all
            of the Prize Draws it makes available. All entries made using any
            Free Alternative Method of Entry are treated the same as any paid
            entries and have an equal chance of winning a prize as any paid
            entries in Prize Draws that they are entered in to.
          </p>

          <h3>3. PRIVACY POLICY</h3>
          <p>
            By clicking "I ACCEPT" or using the Site, you represent that you
            have read and consent to our Privacy Policy in addition to these
            Terms. DAYMADE may revise the Privacy Policy at any time, and the
            new versions will be posted on the Site. If at any point, you do not
            agree to any portion of the Privacy Policy, you must immediately
            stop using the Site.
          </p>

          <h3>4. THE SITE</h3>
          <p>
            The Site provides Prize Draws for a chance to win a variety of
            prizes (Prizes) that may change from time to time. Individuals may
            enter Prize Draws by creating an Account with DAYMADE and then
            purchasing entries in the Prize Draws or by using DAYMADE's Free
            Alternate Method of Entry. No purchase, payment or other financial
            contribution is necessary to enter or win a Prize Draw, and any and
            all Prize Draws are void where prohibited by law.
          </p>
          <p>
            DAYMADE reserves the right to add, change, modify, suspend or
            discontinue any portion of the Site, in its sole discretion, at any
            time. Your use of the Site, including the availability of new
            functionality made available through the Site from time to time,
            shall be subject to these Terms. In addition, DAYMADE may impose
            limits on any portion of the Site or restrict your access to
            portions of the Site in its sole discretion without notice or
            liability.
          </p>

          <h3>5. PURCHASING ENTRIES</h3>
          <p>
            In addition to at least one Free Method of Entry, each Prize Draw
            allows purchasing entries for chances to win the prizes on offer for
            that Prize Draw. The pricing and availability of entries is subject
            to change and may vary from one Prize Draw to the next. All prices
            will be made clear prior to purchase.
          </p>
          <p>
            From time to time we may offer a promotion for new paying users,
            such as '50% off your first entry (
            <span style={{ textDecoration: 'line-through' }}>£2.95</span>{' '}
            £1.73)'. Offers for new users can only be used once.
          </p>

          <h3>6. REFERRAL ENTRIES</h3>
          <p>
            DAYMADE may make available from time to time reward schemes for
            CustomerCustomers that successfully invite other Customers to play.
            Where such a reward scheme involves awarding discounts to the
            inviter, invitee, or both, the reward will be subject to the
            following requirements:
          </p>
          <ol>
            <li>
              The inviter must be an active paying Lite or Premium Customer;
            </li>
            <li>
              The invitee visited the Site using the inviter's referral link
              prior to registering a DAYMADE account for the first time; and
            </li>
            <li>
              The invitee had not previously visited the Site using another
              Customer's referral link.{' '}
            </li>
          </ol>
          <p>
            If the above requirements are met, then the reward to the inviter,
            invitee, or both will be attributed to their account within five
            working days (Successful Referral).
          </p>
          <p>
            Any reward awarded to a Customer for a Successful Referral will have
            no cash value and is not redeemable for cash under any
            circumstances.
          </p>
          <p>
            DAYMADE reserves the right to remove, amend or otherwise alter any
            referral reward schemes at any time and without notice.
          </p>
          <p>
            Where it is found that a referral reward scheme is being abused
            through the use of multiple accounts for the same individual, or any
            other means, then DAYMADE reserves the right at its sole discretion
            to close the accounts of the offenders and revoke any entries
            awarded.
          </p>

          <h3>7. ENTRIES AWARDED AS PRIZES</h3>
          <p>
            DAYMADE may award entries into an upcoming Prize Draw as a prize in
            an earlier Prize Draw (Award Entry) . Prize Draw entries awarded to
            Customers as prizes have no cash value and are not redeemable for
            cash under any circumstances. The numbers used for any entries
            awarded in these circumstances will be generated randomly and
            Customers will not be able to choose the numbers used for these
            entries.
          </p>

          <h3>8. SUBSCRIPTION ENTRIES</h3>
          <p>
            DAYMADE provides the option to purchase entries on a subscription
            basis. Where this is made available as an option, you must
            explicitly ‘opt-in’ to subscription payments and the price and
            payment frequency of these subscription payments will be made clear
            before you choose to ‘opt-in’. When you choose to ‘opt-in’ for
            subscription payments for a specific Prize Draw entry, DAYMADE will
            charge the cost of this entry to your chosen payment method, as set
            out in your Account. The same entry numbers will subsequently be
            purchased in the next available Prize Draw.
          </p>
          <p>
            You will be able to view a history of your subscription payments in
            your Account.
          </p>
          <p>
            In order to process your subscription payments, we will store a
            unique token representing your payment information as stored by our
            3rd party payment provider. This token will be used to perform
            ‘cardholder not present’ transactions (When a customer types in
            their payment details themselves, that is considered a ‘cardholder
            present’ transaction - when we initiate a subscription renewal as a
            company, that is considered a ‘cardholder not present’ transaction)
            using your payment information each time a payment is due for your
            subscriptions. Users who send postal entries on a weekly basis are
            treated as Subscribers and will benefit from the same perks.
          </p>
          <p>
            DAYMADE may from time to time offer free entries on a subscription
            basis. A free subscription may differ in benefits and prizes from
            the paid subscription option, which will be clearly communicated by
            DAYMADE on the Site..
          </p>

          <h3>9. SUBSCRIPTION CANCELLATIONS</h3>
          <p>
            Subscriptions may be cancelled at any time from your Account. If you
            cancel a subscription, you will no longer be a Subscriber and will
            not be charged for that particular subscription with effect from the
            date of cancellation.
          </p>
          <p>
            If you start a new subscription using the "Subscribe & get 1st entry
            free" promotion and you cancel your subscription before the draw
            takes place, your free entry will be invalidated and will not take
            part in the draw.
          </p>

          <h3>10. REFUNDS</h3>
          <p>
            DAYMADE Prize Draw entries that have been purchased using the Site
            or via subscription are non-refundable under normal circumstances.
            If DAYMADE has to cancel a Prize Draw after entries have already
            been purchased then the amounts paid will be refunded to the payment
            methods used to purchase those entries by Customers and Subscribers.
          </p>

          <h3>11. INTERNET ACCESS</h3>
          <p>
            You are responsible for any internet connection and
            telecommunication fees and charges that you incur when accessing the
            Site.
          </p>

          <h3>12. ACCOUNTS</h3>
          <p>
            To use certain portions of the Site, you will be directed to
            register on the Site and create a Customer profile or account
            (Account). Eligibility is limited to those who are at least 18 years
            old and resident in the UK. As part of the registration process, you
            will be required to provide personal information including contact
            details. You agree that all information you provide to DAYMADE for
            the purposes of creating an account (Registration Information) will
            be true, accurate, current and complete and your failure to provide
            such information shall constitute a breach of these Terms and may
            result in the immediate termination of your Account. You shall (i)
            promptly update your Registration Information to keep it true,
            accurate, current and complete; and (ii) maintain the
            confidentiality of your password.
          </p>
          <p>
            In creating an Account, you shall not (a) select or use the email
            address or User name of another person with the intent to
            impersonate that person, (b) use a name subject to the rights of any
            other person without authorisation, (c) use an email address or User
            name that is profane, offensive or otherwise inappropriate or (d)
            allow any other party to use your Account and/or password except as
            set forth herein.
          </p>
          <p>
            You may not share or transfer your Account to a third party. You may
            not disclose your password to anyone. You agree to immediately
            notify DAYMADE by sending an email to info@daymade.co.uk of any
            known or suspected unauthorised use(s) of your Account or any known
            or suspected breach of security, including loss, theft or
            unauthorised disclosure of your password. You understand and agree
            that you shall be liable for all activities that occur under any
            Account created for your use, even if such activities were not
            committed by you. DAYMADE is not responsible for any loss or damage
            arising from your failure to maintain the confidentiality of your
            password.
          </p>
          <p>
            DAYMADE employees and directors may not participate in any of the
            Prize Draws made available on the Site.
          </p>

          <h3>13. TERMINATION OF ACCOUNT</h3>
          <p>
            You understand and agree that you have no ownership rights in your
            Account and DAYMADE may gain access to your Account at any time.
            Further, DAYMADE may cancel your Account, delete all of your
            Registration Information and any other information you have provided
            through the Site (collectively, User Content) associated with your
            Account at any time, without notice, for any reason including,
            without limitation, your violation of these Terms. DAYMADE will not
            be liable for any damages or loss resulting from the removal of any
            User Content from the Site. You may cancel your Account at any time
            and cancellation will take effect immediately. DAYMADE reserves the
            right to temporarily or permanently restrict or block access to the
            Site to any Users.
          </p>

          <h3>14. Policy for vulnerable players</h3>
          <p>
            DAYMADE is committed to ensuring that draw tickets are not knowingly
            sold to vulnerable people such as someone under the influence of
            alcohol or drugs, or someone who is incoherent, or suffering from
            dementia or Alzheimer’s disease etc. DAYMADE will politely refuse to
            assist vulnerable people in purchasing draw entries, and may
            recommend that the customer speaks with a carer or family member,
            before proceeding with the transaction. DAYMADE will monitor any
            ongoing communications with customers in order to try and detect
            whether a person’s vulnerability becomes evident, such that the
            customer’s weekly membership can be cancelled and any game-related
            future communications can be terminated.
          </p>

          <h3>15. LIMITED LICENSE TO USE SITE</h3>
          <p>
            Subject to these Terms, DAYMADE hereby grants you a limited,
            non-exclusive, personal, non-sublicensable, non-assignable license
            to access and use the Site. The Site may only be used for personal
            and non-commercial purposes and must at all times be used in
            accordance with these Terms and rules, restrictions and/or
            documentation set forth by DAYMADE from time to time. All
            modifications and enhancements to the Site remain the sole property
            of DAYMADE. You agree not to license, create derivative works from,
            transfer, sell or re-sell any information, content, or services
            obtained from the Site. You understand that DAYMADE, in its sole
            discretion, may at any time for any reason suspend or terminate any
            license hereunder and disable the Site, or any part thereof, without
            prior notice. DAYMADE reserves the right to add or remove features
            or functions to the Site at any time in its sole discretion.
            Notwithstanding anything to the contrary herein, you may not: (i)
            cause, permit or authorise the modification, creation of derivative
            works, translation, reverse engineering, decompiling, disassembling
            or hacking of the Site; (iii) sell, assign, rent, lease, act as a
            service bureau, or grant rights in the Site, including, without
            limitation, through sublicense, to any other entity without the
            prior written consent of DAYMADE; or (iv) make any false, misleading
            or deceptive statement or representation regarding DAYMADE and/or
            the Site.
          </p>

          <h3>16. USE OF SITE AND SERVICE</h3>
          <p>
            You agree that you will not, in connection with your use of the
            Site, violate any applicable law or regulation. Without limiting the
            foregoing, you agree not to (i) make available through the Site any
            material or information that infringes any copyright, trademark,
            patent, trade secret, or other right of any party (including rights
            of privacy or publicity); (ii) institute, assist, or become involved
            in any type of attack including, without limitation, denial of
            service attacks, upon the Site or otherwise attempt to disrupt the
            Site or any other person's use of the Site; or (iii) attempt to gain
            unauthorised access to the Site, Accounts registered to other Users,
            or the computer systems or networks connected to the Site.
            Furthermore, you may not use the Site to develop, generate, transmit
            or store information that: (a) is defamatory, harmful, abusive,
            obscene or hateful; (b) in any way obstructs or otherwise interferes
            with the normal performance of another person's use of the Site, (c)
            performs any unsolicited commercial communication not permitted by
            applicable law; (d) constitutes harassment or a violation of privacy
            or threatens other people or groups of people; (e) is harmful to
            children in any manner; (f) violates any applicable law, regulation
            or ordinance; (g) makes any false, misleading or deceptive statement
            or representation regarding DAYMADE and/or the Site or (h)
            constitutes phishing, pharming or impersonates any other person, or
            steals or assumes any person's identity (whether a real identity or
            online nickname or alias).
          </p>
          <p>
            You agree that you will not (i) obtain or attempt to obtain any
            information from the Site including, without limitation, email
            information of other Account holders or other Software data; (ii)
            intercept, examine or otherwise observe any proprietary
            communications protocol used by the Site or Software, whether
            through the use of a network analyser, packet sniffer or other
            device; or (iii) use any type of bot, spider, virus, clock, timer,
            counter, worm, software lock, drop dead device, Trojan-horse
            routing, trap door, time bomb or any other codes, instructions or
            third-party software that is designed to provide a means of
            surreptitious or unauthorised access to, or distort, delete, damage
            or disassemble, the Site.
          </p>
          <p>
            You understand that all data, information, text, software, graphics,
            video, messages, tags, or other materials (Content), whether
            publicly posted or privately transmitted, on the Site or through the
            use of the Site, are the sole responsibility of the person posting
            or transmitting such Content. DAYMADE does not control the Content
            posted on the Site or transmitted through the use of the Site and,
            as such, DAYMADE does not guarantee, and shall not be responsible
            for any deficiencies relating to, the accuracy, reliability or
            quality of such Content. Further, you acknowledge that DAYMADE may
            not pre-screen Content that is displayed on the Site or transmitted
            through the use of the Site. You understand that by visiting the
            Site, you may be exposed to Content that you may consider to be
            offensive, indecent or objectionable. Under no circumstances will
            DAYMADE be liable in any way for any User-generated Content
            including, but not limited to, any errors or omissions in any
            Content, or any loss or damage of any kind incurred as a result of
            the use of any Content posted, emailed, transmitted or otherwise
            made available on the Site or through the use of the Site.
          </p>
          <p>
            The Site may provide forums and/or chat features enabling Users to
            post User observations and comments. We cannot guarantee that other
            members or Users will not use the ideas and/or information that you
            share. If you have ideas and/or information that you want to remain
            confidential and/or do not want others to use, do not post them via
            the Site. We shall have no responsibility to evaluate, use or
            compensate you for any ideas and/or information that you submit on
            the Site or through the use of the Site.
          </p>
          <p>
            All comments, feedback, suggestions, ideas, and other submissions
            that you disclose, submit or offer to us in connection with your use
            of the Site, such as your suggestions regarding improvements that we
            make to the Site (collectively, Comments) will become our exclusive
            property once they are posted on the Site. Such disclosure,
            submission or offer of any Comments shall constitute an assignment
            to us of all worldwide right, title and interest in all patent,
            copyright, trademark, and all other intellectual property and other
            rights whatsoever in and to the Comments and a waiver of any claim
            based on moral rights, unfair competition, breach of implied
            contract, breach of confidentiality, and any other legal theory
            relating to submissions. Thus, we will own exclusively all such
            right, title and interest and shall not be limited in any way in the
            use, commercial or otherwise, of any Comments. You should not submit
            any Comments to us if you do not wish to assign such rights to us.
            We are and will be under no obligation: (i) to maintain any Comments
            in confidence; (ii) to pay to you or any third party any
            compensation for any Comments; or (iii) to respond to any Comments.
            You are and shall remain solely responsible for the content of any
            Comments you make before they are posted on the Site. By posting
            Comments or any other content, you warrant and represent that you
            own the rights to such or are otherwise authorised to post,
            distribute, display, perform, transmit, or otherwise distribute such
            Comments and content and grant us the right to do the same. You
            hereby irrevocably waive any claims based on moral rights and
            similar theories, if any.
          </p>
          <p>
            Your User Content, and the contents of all of your Comments and
            other online communications (including without limitation chat text,
            voice communications, IP addresses and your personal information)
            may be accessed and monitored by DAYMADE as necessary to operate the
            Site and may be disclosed to a third party: (i) when we have a good
            faith belief that we are required to disclose the information in
            response to legal process (for example, a court order, search
            warrant or subpoena); (ii) to satisfy any applicable laws or
            regulations (iii) where we believe that the Site is being used in
            the commission of a crime, including to report such criminal
            activity or to exchange information with other companies and
            organisations for the purposes of fraud protection and credit risk
            reduction; (iv) when we have a good faith belief that there is an
            emergency that poses a threat to the health and/or safety of you,
            another person or the public generally; and (v) in order to protect
            the rights or property of DAYMADE, including to enforce these Terms.
            By accepting these Terms, you hereby provide your irrevocable
            consent to such monitoring, access and disclosure.
          </p>
          <p>
            When accessing the Site, you agree to obey the law and to respect
            the intellectual property rights of others. Your use of the Site is
            at all times governed by and subject to laws regarding copyright
            ownership and use of intellectual property. You agree not to upload,
            download, display, perform, transmit, or otherwise distribute any
            information or content in violation of any third party's copyrights,
            trademarks, or other intellectual property or proprietary rights.
            You shall be solely responsible for any violations of any relevant
            laws and for any infringements of third party rights caused by any
            content you provide or transmit, or that is provided or transmitted
            using your account. The burden of proving that any content does not
            violate any laws or third party rights rests solely with you.
          </p>
          <p>
            The Site is operated by DAYMADE in the United Kingdom. Those who
            choose to access and use the Site from locations outside the United
            Kingdom do so on their own initiative and are responsible for
            compliance with applicable local laws.
          </p>

          <h3>17. THIRD PARTY PRODUCTS</h3>
          <p>
            Third party services, content, information and products may be made
            available by DAYMADE on or through the Site (Third Party Products).
            Third Party Products are provided solely for the convenience of any
            person who accesses the Site and DAYMADE makes no representations or
            warranties regarding any Third Party Products and takes no
            responsibility and assumes no liability for any Third Party
            Products. Third Party Products are subject to the applicable terms
            and policies of the third parties that offer them.
          </p>

          <h3>18. HYPERLINKS</h3>
          <p>
            The Site may contain links to websites operated by other parties.
            DAYMADE provides these links to other websites as a convenience, and
            use of these sites is at your own risk. The linked sites are not
            under the control of DAYMADE, and DAYMADE is not responsible for the
            content available on the other sites. Such links do not imply
            DAYMADE's endorsement of information or material on any other site
            and DAYMADE disclaims all liability with regard to your access to
            and use of such linked websites.
          </p>
          <p>
            You may not place a link to the Site on another website unless you
            adhere to DAYMADE's linking policy as follows: (i) the appearance,
            position and other aspects of the link may not be such as to damage
            or dilute the goodwill associated with DAYMADE and/or its names and
            trademarks, (ii) the appearance, position and other attributes of
            the link may not create the false appearance that your organisation
            or entity is sponsored by, affiliated with, or associated with
            DAYMADE, (iii) when selected by a user, the link must display the
            Site on full-screen and not within a frame on the linking site, and
            (iv) DAYMADE reserves the right to revoke its consent to the link at
            any time and in its sole discretion.
          </p>

          <h3>19. INTELLECTUAL PROPERTY</h3>
          <p>
            The interfaces, content, arrangement and layout of the Site
            including, but not limited to, the DAYMADE trademark and logo,
            designs, text, artwork, graphics, images, buttons, User interfaces,
            information and other content, and any compilation of the foregoing
            (DAYMADE Intellectual Property) are the property of DAYMADE, except
            where otherwise noted, and are protected from copying, imitation,
            communication, or simulation under international laws and may not be
            reproduced, modified, communicated, displayed, distributed, or
            transmitted without the prior written permission of DAYMADE. You
            understand and acknowledge that, by visiting the Site, you do not
            acquire or obtain by implication or otherwise, any license or right
            to use or make additional copies of any materials or information
            displayed on the Site. You agree not to display or use any DAYMADE
            Intellectual Property or third party content located on the Site in
            any manner not expressly permitted under these Terms.
          </p>
          <p>
            We respect the copyrights of others and expect our Users to do the
            same. We have a policy of terminating the Accounts of Users who
            repeatedly infringe the copyrights of others. If you learn or
            believe that the Site or any information on the Site, including any
            Content, infringes upon any copyright or other intellectual property
            that you own or control, you may file a notice to us by emailing us
            at info@daymade.co.uk. In the event of any third party claim that
            the Site infringes that third party's intellectual property rights,
            we will be solely responsible for the investigation, defence,
            settlement and discharge of any such intellectual property
            infringement claim.
          </p>

          <h3>20. DISCLAIMER OF WARRANTIES</h3>
          <p>
            The Site is provided on an ‘as is’ and ‘as available’ basis for your
            use, without warranties of any kind, either express or implied,
            including without limitation, warranties of satisfactory quality,
            merchantability, fitness for a particular purpose, title,
            non-infringement, and those arising from course of dealing or usage
            of trade. DAYMADE makes no warranty as to the quality, accuracy,
            completeness or reliability of any content available through, or the
            performance of, the Site. You are responsible for verifying any
            information before relying on it. Use of the Site is at your sole
            risk. DAYMADE does not warrant that you will be able to access or
            use the Site at the times or locations of your choosing; that the
            operation of the Site will be uninterrupted or error-free; that
            defects will be corrected; or that the Site is free of viruses or
            other harmful components.
          </p>
          <p>
            DAYMADE provides no warranty or guarantee of any kind that the Site
            will meet your expectations or requirements.
          </p>

          <p>
            Because some jurisdictions do not allow the disclaimer of implied
            warranties, the foregoing disclaimers may not apply to you.
          </p>

          <h3>21. LIMITATION OF LIABILITY</h3>
          <p>
            To the maximum extent permitted by law, in no event shall DAYMADE or
            any of its affiliates, together with its respective directors,
            officers, shareholders, employees and agents, be liable with respect
            to any subject matter of these Terms, whether based in contract,
            tort (including negligence), strict liability or other legal or
            equitable theory for (i) for any lost or corrupted data, lost
            profits, loss or damage to any computer, mobile phone or other
            device or any indirect, incidental, consequential, or special or
            exemplary damages arising out of or in any way connected with access
            to or use of the Site, even if DAYMADE and/or its affiliates have
            been advised of the possibility of such damages; (ii) the use or the
            inability to use the Site; (iii) unauthorised access to or
            alteration of your transmissions or data; (iv) statements or conduct
            of any third party on the Site; (v) any other matter relating to the
            Site; or (vi) the cost of procuring substitute goods, services or
            technology. To the full extent permissible under applicable law,
            DAYMADE's aggregate liability to you or any third party in any
            circumstance shall not exceed one hundred and twenty pounds (£120).
            You acknowledge and agree that your sole remedy for any problems or
            dissatisfaction with the Site is to terminate your account and
            discontinue use of the Site.
          </p>
          <p>
            Because some jurisdictions do not allow the exclusion or the
            limitation of liability for consequential or incidental damages, in
            such jurisdictions, the liability of DAYMADE and its affiliates
            shall be limited to the fullest extent permitted by law.
          </p>

          <h3>22. INDEMNIFICATION</h3>
          <p>
            You agree to defend, indemnify and hold DAYMADE, and its successors
            and assigns, and their respective officers, directors, affiliates,
            agents and employees, harmless from and against any and all claims,
            actions, proceedings and suits and all related liabilities, losses,
            damages, judgments, settlements, penalties, fines, costs and
            expenses (including, without limitation, reasonable legal fees and
            costs) arising out of or relating to (i) your use or misuse of the
            Site, (ii) your breach or alleged breach of these Terms, including,
            without limitation, a breach or alleged breach of any representation
            or warranty by you in these Terms; (iii) your violation of any law,
            rule, regulation or rights of others in connection with your use of
            the Site, or (iv) infringement, violation or misappropriation of any
            copyright, trade secret, or any other intellectual property rights
            or the violation of any property or privacy right arising from any
            of the User Content or Comments that you post on the Site.
          </p>

          <h3>23. ANTI MONEY LAUNDERING POLICY</h3>
          <ol className="pl-[15px]">
            <li>
              On top of complying with all conditions as laid out by “The
              Gambling Act 2005” in relation to prize competitions, DAYMADE has
              put in place measures to prevent its systems from being used for
              the purposes of money laundering, terrorist financing or any other
              criminal activity.
            </li>
            <li>
              DAYMADE is committed to preventing money laundering and combatting
              the financing of terrorism in order to minimise and manage its
              reputational risk, legal risk and regulatory risk. It is also
              committed to its wider social responsibility in preventing crime
              by not allowing its systems to be used to commit crimes.
            </li>
            <li>
              In order to adhere to Anti Money Laundering regulations and
              requirements, DAYMADE shall:
              <ul className="pl-[15px]">
                <li>
                  Appoint a designated Money Laundering Reporting Officer (MLRO)
                  whose responsibility it is to report possible acts of money
                  laundering to the authorities. This role belongs to Lisa
                  Nederveen.
                </li>
                <li>
                  Take reasonable steps to establish the identity of any person
                  for whom it is proposed to provide its service.
                </li>
                <li>
                  Keep at all times a secure online list of all registered
                  Players.
                </li>
                <li>
                  Retain identification and transactional documentation for each
                  Player.
                </li>
                <li>
                  Provide initial and ongoing training to all relevant staff so
                  that they are aware of their personal responsibilities and the
                  procedures in respect of identifying Players, monitoring
                  Player activity, record-keeping and reporting any
                  unusual/suspicious transactions.
                </li>
                <li>
                  Ensure that this policy is reviewed and maintained regularly.
                </li>
                <li>
                  Examine, as much as is possible, the background and purpose of
                  any complex or large transactions or groups of transactions
                  which are likely, by their nature, to be related to money
                  laundering or the funding of terrorism.
                </li>
                <li>
                  Not accept or open anonymous Accounts or Accounts in
                  fictitious names such that the true beneficial owner is not
                  known.
                </li>
                <li>
                  Not register a Player who is under eighteen (18) years of age.
                </li>
                <li>
                  Only register a single account in the name of a particular
                  person.
                </li>
                <li>
                  Transfer payments of winnings or refunds back to the same
                  route from where the funds originated, where possible.
                </li>
                <li>
                  Not accept cash from Players. Funds may be received from
                  Players only by any of the approved methods.
                </li>
                <li>
                  Terminate a Player’s registration if it becomes aware that a
                  person has provided false information when onboarding.
                </li>
                <li>
                  Report any suspicion or knowledge of money laundering or
                  terrorism financing to the authorities.
                </li>
                <li>
                  Cooperate with all relevant administrative, enforcement and
                  judicial authorities in their endeavour to prevent and detect
                  criminal activity.
                </li>
              </ul>
            </li>
          </ol>

          <h3>24. GOVERNING LAW AND JURISDICTION</h3>
          <p>
            These Terms shall be governed by, and will be construed under, the
            laws of England, without regard to choice of law principles. All
            disputes arising out of or related to your use of the Site shall be
            subject to the exclusive jurisdiction of the courts in England and
            you agree to submit to the personal jurisdiction of such courts.
          </p>

          <h3>25. GENERAL</h3>
          <p>
            These Terms shall be governed by, and will be construed under, the
            laws of England, without regard to choice of law principles. All
            disputes arising out of or related to your use of the Site shall be
            subject to the exclusive jurisdiction of the courts in England and
            you agree to submit to the personal jurisdiction of such courts.
          </p>
          <p>
            You agree that no joint venture, partnership, employment, or agency
            relationship exists between you and DAYMADE as a result of these
            Terms or your use of the Site.
          </p>
          <p>
            DAYMADE may assign these Terms, in whole or in part, to any person
            or entity at any time with or without your consent. You may not
            assign these Terms without DAYMADE's prior written consent, and any
            unauthorised assignment by you shall be null and void.
          </p>
          <p>
            If any of the provisions of these Terms is found to be invalid or
            unenforceable, then that provision will be construed in a manner
            consistent with applicable laws to reflect, as nearly as possible,
            the original intentions of the parties, and the remaining provisions
            shall remain in full force and effect.
          </p>
          <p>
            In the event any litigation is brought by either party in connection
            with these Terms, the prevailing party in such litigation shall be
            entitled to recover from the other party all the reasonable costs,
            legal fees and other expenses incurred by such prevailing party in
            the litigation.
          </p>
          <p>
            Our failure to enforce any provision of these Terms shall in no way
            be construed to be a present or future waiver of such provision, nor
            in any way affect the right of any party to enforce each and every
            such provision thereafter. The express waiver by us of any
            provision, condition or requirement of these Terms shall not
            constitute a waiver of any future obligation to comply with such
            provision, condition or requirement.
          </p>
          <p>
            All notices given by you or required under these Terms shall be in
            writing and should be emailed to info@daymade.co.uk.
          </p>
          <p>
            DAYMADE shall not be liable for any delay or failure in performance
            of any part of its obligations to the extent that such delay or
            failure is caused by any cause beyond its reasonable control
            including, without limitation, fire, flood, strikes, lock-outs,
            hardware, software or telecommunications failure or any government
            action.
          </p>
          <p>
            DAYMADE shall be entitled, without any liability on its part, to
            alter, suspend or terminate any of its Services on the Site.
          </p>
          <p>
            You hereby agree that DAYMADE would be irreparably damaged if these
            Terms were not specifically enforced, and therefore you agree that
            we shall be entitled, without bond, other security, or proof of
            damages, to appropriate equitable remedies with respect any breach
            of these Terms, in addition to such other remedies as we may
            otherwise have available to us under applicable laws.
          </p>
          <p>
            These Terms, including the documents expressly incorporated by
            reference, constitutes the entire agreement between you and us with
            respect to the Site and supersedes all prior or contemporaneous
            communications, whether electronic, oral or written, between you and
            us with respect to the Site.
          </p>

          <h3>26. PRIZE DRAW RULES</h3>

          <h4>Weekly Draws (Tuesday & Friday)</h4>

          <p>
            The following describes the rules and procedures by which DAYMADE
            operates its Weekly Draws and determines winners.
          </p>

          <h5>Weekly Draw Entries</h5>

          <p>
            Weekly Draw entries consist of four numbers between 1-55 (Main
            Numbers) and one number between 1-10 (Bonus Ball Number). For the
            purposes of these terms and conditions, a vertical bar splits the
            four Main Numbers from the Bonus Ball Number. So, for example,
            '1,2,3,4|5' represents a Weekly Draw entry with 1, 2, 3, and 4 as
            the Main Numbers, and 5 as the Bonus Ball Number.
          </p>
          <p>
            Main Numbers can be selected only once (i.e. no duplicates among
            Main Numbers), however the Bonus Ball Number can be a duplicate of
            one of the Main Numbers, although it doesn't have to be. For
            example, these are valid entries: '39,12,24,2|9' and '2,55,14,5|5'.
            And this is an invalid entry as it contains a duplicated Main Entry
            number ('32'): '32,42,15,32|4'. When purchasing more than one entry,
            it is not possible to have an identical set of numbers for each
            entry.
          </p>
          <p>
            The order and position of the Main Numbers is irrelevant when
            comparing the Main Numbers of the Winning Line. The Bonus Ball
            Number is drawn from a separate pool and is compared only to the
            Bonus Ball Number from the Weekly Draw entry. For example, if your
            Weekly Draw entry is '1,2,3,4|5' and the winning line is
            '4,3,1,5|2', you will have matched 3 Main Numbers ('1', '3', '4') as
            their order is not important, but you will not have matched the
            Bonus Ball Number (the winning Bonus Ball Number of '2' does not
            match your Bonus Ball Number of '5').
          </p>
          <p>
            Matches with the Winning Numbers are counted per entry and cannot be
            combined. For example, if you have one entry with ‘1,2,3,4|1’ and
            one entry with ‘6,7,8,1|4’ and the Winning Numbers are ‘1,2,7,6|4’,
            you will win a Bronze prize (as you have matched '1' and '2' in the
            Main Numbers of your first entry) and a Platinum prize (as you have
            matched 3 Main Numbers + Bonus Ball Number in your second entry).
          </p>
          <p>
            The numbers and ranges available for selection may be amended from
            time to time at DAYMADE's sole discretion. Any changes would only be
            made for future Weekly Draws for which no entries have been
            purchased.
          </p>
          <p>
            For a given calendar month (e.g. 1st January - 31st January),
            players may spend no more than £120 on any of our paid products
            combined. You may obtain up to four entries in each Weekly Draw
            (regardless of whether you purchase them online or use the postal
            entry method). Any further attempts to enter online or via post will
            be blocked or discarded.
          </p>

          <h5>Timing and Frequency of Weekly Draws</h5>
          <p>
            DAYMADE will perform two draws per week: one on Tuesday and one on
            Friday (each a Weekly Draw) . DAYMADE may amend the date, time and
            frequency that it performs Weekly Draws at any time and at its sole
            discretion.
          </p>
          <p>
            The date and time of the next available Weekly Draw will always be
            available on the website and made known to Customers prior to
            purchasing any entries in that Weekly Draw.
          </p>

          <h5>Conducting Weekly Draws</h5>
          <p>
            Each Weekly Draw will have an associated lock down time. From this
            moment onwards no further entries into this Weekly Draw will be
            possible. The winning numbers for a Weekly Draw will never be
            determined until we have verified that no further entries are able
            to enter into the Weekly Draw.
          </p>
          <p>
            Once all entries have been confirmed and the Weekly Draw is locked
            down, DAYMADE will use a random number generator service or its own
            random number generators to generate winning numbers in the same
            range as used for entries. The winning numbers will be recorded and
            then used to determine which entries have won prizes.
          </p>

          <h5>Determining Winners</h5>
          <p>
            Once the winning numbers have been determined, the numbers from each
            valid entry in the Weekly Draw will be compared to determine how
            many matches have been made. The number of matches made will
            determine whether or not a prize has been won and which prize will
            be awarded if a prize has been won, according to the Prize Table in
            the section below.
          </p>
          <p>
            There is no limit to how many valid entries can win each of the
            prize tiers.
          </p>
          <p>
            An entry will always be awarded only the highest valued prize it is
            eligible for. For example, an entry matching four Main Numbers will
            also match three Main Numbers. In this instance it would only be
            awarded the prize for matching four Main Numbers.
          </p>
          <p>
            The jackpot prize is £25,000 for Premium entries and £10,000 for
            Lite entries, unless a player actively opted-in to the £100,000
            jackpot boost. Players can opt-in and opt-out of the £100k jackpot
            at any time from their account.
          </p>
          <p>
            In the case of multiple jackpot winners (4 main number matches +
            bonus ball match) in the same draw, the jackpot prize will be split
            between the winners. For example, if two players match 4 main
            numbers + bonus ball in the same draw, the jackpot (a DAYMAKER prize
            or a DAYMAKERboost prize if you opted to ‘boost’ your jackpot) will
            be split between the two players, with each player receiving a prize
            worth half the value of a DAYMAKER/DAYMAKERboost prize.
          </p>

          <h5>
            Weekly Draws Prize Table (valid for Premium and postal entries)
          </h5>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Number of Number Matches</th>
                <th>Prize</th>
                <th>Chance of Prize Being Won Per Entry</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>4 + Bonus Ball (with 'boosted' jackpot)</td>
                <td>
                  JACKPOT: Any DAYMAKERboost prize up to £100,000 in value
                </td>
                <td>1 / 3,410,550</td>
              </tr>
              <tr>
                <td>4 + Bonus Ball (without 'boosted' jackpot)</td>
                <td>JACKPOT: Any DAYMAKER prize up to £25,000 in value</td>
                <td>1 / 3,410,550</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Any Diamond prize up to £10,000 in value</td>
                <td>1 / 378,950</td>
              </tr>
              <tr>
                <td>3 + Bonus Ball</td>
                <td>Any Platinum prize up to £2,000 in value</td>
                <td>1 / 16,718</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Any Gold prize up to £300 in value</td>
                <td>1 / 1,858</td>
              </tr>
              <tr>
                <td>2 + Bonus Ball</td>
                <td>Any Silver prize up to £50 in value</td>
                <td>1 / 446</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Any Bronze prize up to £25 in value</td>
                <td>1 / 50</td>
              </tr>
              <tr>
                <td>1 + Bonus Ball</td>
                <td>
                  Choice of 2 Weekly Draw entries, 10 DAYMADE Tokens or 10 trees
                  planted
                </td>
                <td>1 / 41</td>
              </tr>
              <tr>
                <td>1</td>
                <td>Choice of 1 Weekly Draw entry or 5 trees planted</td>
                <td>1 / 5</td>
              </tr>
              <tr>
                <td>0 + Bonus Ball</td>
                <td>
                  Choice of 1 DAYMADE Token (can be saved up and exchanged for
                  free entries) or 1 tree planted
                </td>
                <td>1 / 14</td>
              </tr>
            </tbody>
          </table>

          <h5>Weekly Draws Prize Table (valid for Lite entries)</h5>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Number of Number Matches</th>
                <th>Prize</th>
                <th>Chance of Prize Being Won Per Entry</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>4 + Bonus Ball (with 'boosted' jackpot)</td>
                <td>
                  JACKPOT: Any DAYMAKERboost prize up to £100,000 in value
                </td>
                <td>1 / 3,410,550</td>
              </tr>
              <tr>
                <td>4 + Bonus Ball (without 'boosted' jackpot)</td>
                <td>JACKPOT: Any Diamond prize up to £10,000 in value</td>
                <td>1 / 3,410,550</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Any Platinum prize up to £2,000 in value</td>
                <td>1 / 378,950</td>
              </tr>
              <tr>
                <td>3 + Bonus Ball</td>
                <td>Any Gold prize up to £300 in value</td>
                <td>1 / 16,718</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Any Silver prize up to £50 in value</td>
                <td>1 / 1,858</td>
              </tr>
              <tr>
                <td>2 + Bonus Ball</td>
                <td>Any Bronze prize up to £25 in value</td>
                <td>1 / 446</td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  Choice of 2 Weekly Draw entries, 10 DAYMADE Tokens or 10 trees
                  planted
                </td>
                <td>1 / 50</td>
              </tr>
              <tr>
                <td>1 + Bonus Ball</td>
                <td>Choice of 1 Weekly Draw entry or 5 trees planted</td>
                <td>1 / 41</td>
              </tr>
              <tr>
                <td>1</td>
                <td>
                  Choice of 1 DAYMADE Token (can be saved up and exchanged for
                  free entries) or 1 tree planted
                </td>
                <td>1 / 5</td>
              </tr>
              <tr>
                <td>0 + Bonus Ball</td>
                <td>
                  Choice of 1 DAYMADE Token (can be saved up and exchanged for
                  free entries) or 1 tree planted
                </td>
                <td>1 / 14</td>
              </tr>
            </tbody>
          </table>

          <h5>Weekly Draws Prize Table (valid for DAYMADE Free entries)</h5>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Number of Number Matches</th>
                <th>Prize</th>
                <th>Chance of Prize Being Won Per Entry</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>4 + Bonus Ball</td>
                <td>Any Platinum prize up to £2,000 in value</td>
                <td>1 / 3,410,550</td>
              </tr>
            </tbody>
          </table>

          <h5>Free Daily Draw Prize Table</h5>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Number of Number Matches</th>
                <th>Prize</th>
                <th>Prize Value</th>
                <th>Chance of Prize Being Won Per Entry</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>5</td>
                <td>
                  Free Daily Draw Prize (e.g. arctic igloo escape to Finland)
                </td>
                <td>£2,500</td>
                <td>1 / 17,259,390</td>
              </tr>
            </tbody>
          </table>

          <h4>POUND RAFFLE DRAW</h4>

          <h5>RAFFLE ENTRIES</h5>

          <p>
            To become an Entrant into the Pound Raffle with a chance of winning
            the prize in a Pound Raffle Draw, individuals must either enter
            online or via post. Raffle entries are made up of a unique set of
            letters/numbers. The raffle does not need a minimum number of
            entries in order to proceed. The maximum number of entries per
            entrant is 10 entries. For a given calendar month (e.g., 1st January
            - 31st January), players may spend no more than £120 on any of our
            paid products combined.
          </p>

          <h5>TIMING AND FREQUENCY OF PRIZE DRAWS</h5>

          <p>
            The winner for each Pound Raffle Draw will be determined and awarded
            the relevant competition prize(s) so specified on the Site in
            accordance with these Terms. The draw to determine the winner will
            be made on the Draw Date. Unless otherwise specified in the
            description under a competition, DAYMADE will never extend the
            Closing Date for any competition.
          </p>

          <h5>CONDUCTING PRIZE DRAWS</h5>

          <p>
            The option to enter any raffle will end at 21:59 on the day of the
            raffle. From this moment onwards no further entries into the raffle
            of that day will be possible, and purchased entries bought after
            21:59 will be entered into the next raffle. The winning numbers for
            a raffle will never be determined until we have verified that no
            further entries are able to enter in to the raffle. Once all entries
            have been confirmed and the raffle is locked down, DAYMADE will use
            a random number generator service, or its own random number
            generators, to generate a winning corresponding number to one of the
            entries in the associated draw. The winning numbers will be recorded
            and then used to determine which entry has won the prize. DAYMADE’s
            decision is final, and no correspondence will be entered into about
            the result of the competition following the determination of the
            winner.
          </p>

          <h4>TOKEN TOWN RAFFLE DRAWS</h4>

          <h5>RAFFLE ENTRIES</h5>

          <p>
            To become an Entrant into any of the Token Town Raffles with a
            chance of winning the prize, individuals must either enter online or
            via post. Raffle entries are made up of a unique set of
            letters/numbers. For a given calendar month (e.g. 1st January - 31st
            January), Entrants may spend no more than £120 on any of our paid
            products combined.
          </p>

          <h5>TIMING AND FREQUENCY OF PRIZE DRAWS</h5>

          <p>
            The winner for each raffle draw will be determined and awarded the
            relevant competition Prize(s) specified on the Site in accordance
            with these Terms. The draw to determine the winner will be made on
            the Draw Date or, if it’s a raffle with a certain set of minimum
            entries, the draw takes place when the entries are sold out. Unless
            otherwise specified in the description under a competition, DAYMADE
            will never extend the Closing Date for any competition. Unless
            otherwise specified in the description under a Competition, there is
            no Reserve Level, and the Prize will always be given away on the
            Closing Date.
          </p>

          <h5>CONDUCTING PRIZE DRAWS</h5>

          <p>
            The raffle will be locked once the last entry has been sold for it
            (the minimum number of entries have been sold). After this point, no
            further entries can be entered into this raffle (though entries can
            be purchased into any available follow-up raffle). DAYMADE will use
            a random number generator service or its own random number
            generators to generate a winning corresponding number to one of the
            entries in the associated draw. The winning numbers will be recorded
            and then used to determine which entry has won the prize. DAYMADE’s
            decision is final, and no correspondence will be entered into about
            the result of the competition following the determination of the
            winner.
          </p>

          <h4>TOKEN TOWN DAILY DRAWS</h4>

          <h5>DRAW ENTRIES</h5>

          <p>
            To become an Entrant into any of the Token Town Daily Draws with a
            chance of winning the prize, individuals must either enter online or
            via post. Draw entries are made up of unique numbers. Each Entrant
            chooses a number within the range specified on the daily draw game.
            For a given calendar month (e.g. 1st January - 31st January),
            Entrants may spend no more than £120 on any of our paid products
            combined.
          </p>

          <h5>TIMING AND FREQUENCY OF PRIZE DRAWS</h5>

          <p>
            The winner for each daily draw will be determined and awarded the
            relevant competition Prize(s) specified on the Site in accordance
            with these Terms. The draw to determine the winning entry will be
            made on the Draw Date. Unless otherwise specified in the description
            under a Competition, DAYMADE will never extend the Closing Date for
            any competition.
          </p>

          <h5>CONDUCTING PRIZE DRAWS</h5>

          <p>
            The Daily Draws will be locked at 7pm. After this point, no further
            entries can be entered into these draws (though entries can be
            purchased into any available follow-up draw). DAYMADE will use a
            random number generator service or its own random number generators
            to generate a winning corresponding number to one of the entries in
            the associated draw. The winning numbers will be recorded and then
            used to determine which entry has won the prize. If this entry
            corresponds to a sold entry into the Daily Draw, the winner will be
            informed. DAYMADE’s decision is final, and no correspondence will be
            entered into about the result of the competition following the
            determination of the winner.
          </p>

          <h4>CHARITY RAFFLE</h4>

          <h5>RAFFLE ENTRIES</h5>

          <p>
            To become an Entrant into the Charity Raffle with a chance of
            winning the prize, individuals must either enter online or via post.
            As DAYMADE receives no money for postal entries, these entries will
            not contribute to the charity donations. Raffle entries are made up
            of a unique set of letters/numbers. The Raffle does not need a
            minimum number of entries in order to proceed. The maximum number of
            entries per entrant is 10 entries. The £120 cost cap across all
            products for Entrants does not apply to our charity raffle as 100%
            of sales will go to charity and so it is effectively a charity
            donation.
          </p>

          <h5>TIMING AND FREQUENCY OF PRIZE DRAWS</h5>

          <p>
            The winner for each raffle draw will be determined and awarded the
            relevant competition Prize(s) so specified on the Site in accordance
            with these Terms. The draw to determine the winner will be made on
            the Draw Date. Unless otherwise specified in the description under a
            competition, DAYMADE will never extend the Closing Date for any
            competition. Unless otherwise specified in the description under a
            competition, there is no Reserve Level and the Prize will always be
            given away on the Closing Date.
          </p>

          <h5>CONDUCTING PRIZE DRAWS</h5>

          <p>
            The lock down time of the raffle will be 14:59 on the day of the
            raffle. From this moment onwards no further entries into the raffle
            of that day will be possible, and purchased entries bought after
            14:59 will be cancelled or entered into the following raffle. The
            winning numbers for a raffle will never be determined until we have
            verified that no further entries are able to enter in to the raffle.
            Once all entries have been confirmed and the raffle is locked down,
            DAYMADE will use a random number generator service or its own random
            number generators to generate a winning corresponding number to one
            of the entries in the associated draw. The winning numbers will be
            recorded and then used to determine which entry has won the prize.
            DAYMADE’s decision is final, and no correspondence will be entered
            into about the result of the competition following the determination
            of the winner.
          </p>

          <h4>Right to Amend</h4>
          <p>
            DAYMADE reserves the right to amend these Prize Draw rules from time
            to time at its sole discretion. Where such amendments will affect
            the chances of winning then Customers will be informed on the Site
            and via email where applicable to allow Customers to choose if they
            will continue to enter future Prize Draws or not.
          </p>

          <h4>Miscellaneous rules</h4>
          <p>
            DAYMADE and any affiliated parties are not responsible for
            illegible, lost, late, incomplete, misdirected, or undeliverable
            email; or for any computer, telephone, satellite, cable, network,
            electronic or internet hardware or software malfunctions, failures,
            connections, or availability, or garbled, corrupt or jumbled
            transmissions, service provider/internet/website/use net
            accessibility, availability, or traffic congestion, or any
            technical, typographical, or other error, or unauthorised human
            intervention, or the incorrect or inaccurate capture of registration
            information, or the failure to capture, or loss of, any such
            information.
          </p>
          <p>
            By entering Prize Draws, you agree: (a) to be bound by the Prize
            Draw Rules and by all applicable laws and decisions of DAYMADE,
            which shall be binding and final; (b) to waive any rights to claim
            ambiguity with respect to the Prize Draw Rules; (c) to waive all of
            your rights to bring any claim, action, or proceeding against
            DAYMADE and third parties in connection with that Prize Draw; and
            (d) to forever and irrevocably agree to release, defend, indemnify,
            and hold harmless each of the Released Parties from any and all
            claims, lawsuits, judgments, causes of action, proceedings, demands,
            fines, penalties, liability costs and expenses (including, without
            limitation, reasonable outside legal fees) that may arise in
            connection with your participation in a Prize Draw (including any
            Prize).
          </p>
          <p>
            In the event of a dispute regarding entries received from multiple
            Customers having the same email account, the authorised subscriber
            of the email account at the time of entry will be deemed to be the
            entrant and must comply with these rules. The ‘authorised
            subscriber’ of the email account is the natural person who is
            assigned the email address by the Internet Service Provider (ISP),
            online service provider, or other organisation responsible for
            assigning email addresses.
          </p>

          <h3>27. PAYMENT OF PRIZES</h3>
          <p>Prizes won will be paid differently depending on the prize.</p>
          <p>
            Electronically deliverable prizes such as experience vouchers will
            be delivered to winners using the email address they have registered
            with.
          </p>
          <p>
            For travel prizes winners will be contacted via their registered
            email address to arrange a call with someone from the DAYMADE team.
            Winners will not be liable for any postage costs incurred in sending
            the prizes to them. We may ask if winners would be willing to
            participate in a photo shoot with their prize for our promotional
            purposes. If winners agree, then we will hand deliver the prize to
            them at a date and time that we agree upon together. Winners of
            physical prizes will in no way be obligated to do this. Where a
            travel/experience prize has multiple options available then we will
            contact the winner via their registered email address first to
            determine which option they would like. No cash prize alternatives
            are available for physical prizes.
          </p>
          <p>
            We may also require proof of identity and to perform other checks
            prior to booking the holiday. No payment will be required from
            Customers to receive any prize.
          </p>

          <p>
            Winners have 28 days to inform us of their prize of choice.
            Redemption period varies based on choice of prize. By entering
            DAYMADE you play for a variety of prizes. DAYMADE reserves the right
            to add or remove prizes to the selection without notifying the
            customer.
          </p>

          <p>
            Winners of the Platinum, Diamond and DAYMAKER prizes (as specified
            on the Prizes page of this Site) agree to allow DAYMADE to use
            winner content (such as photos/quotes) on the Site and for marketing
            purposes.
          </p>
          <p>
            All winners may have their first name and the initial of their
            surname published in accordance with our Privacy Policy. This may
            include publication on our website and in promotional emails. Use of
            winner names in advertising will only take place with the winner’s
            consent.
          </p>
          <p>
            Adequate travel insurance is a condition of your contract with us.
            You must be satisfied that your travel insurance fully covers all
            your personal requirements including pre-existing medical
            conditions, cancellation charges, medical expenses and repatriation
            in the event of accident or illness. If you are undertaking any
            adventure sports or other such activities as part of your trip, you
            must ensure this is covered by your travel insurance policy. If you
            choose to travel without adequate insurance cover, we will not be
            liable for any losses howsoever arising.
          </p>

          <h3>28. TAXATION OF PRIZES</h3>
          <p>All prizes won from entries sold in the UK are tax free.</p>

          <h3>29. DISPUTES</h3>
          <p>
            You agree that any and all disputes and disagreements between us
            will be governed by the laws of England and you will bring any
            claims only in the courts of England. You also agree that unless you
            are prohibited from law in doing so, you promise you will bring any
            and all disputes, claims and causes of action against DAYMADE
            individually, without resort to any form of class action. Finally,
            unless the law prohibits you from doing so, you agree to waive the
            right to claim any damages whatsoever, including, but not limited
            to, punitive, consequential, direct, or indirect damages and
            participants further waive all rights to have damages multiplied or
            increased.
          </p>

          <h3>30. Gift Cards</h3>
          <p>
            When purchasing a gift card on the Site you are pre-paying for a
            weekly subscription of your chosen duration for our Friday Weekly
            Draw. Gift Cards are non-refundable and cannot be exchanged for cash
            or for any other products.
          </p>

          <p>
            Gift Card recipients will be treated the same as our Subscribers,
            meaning they will have the exact same odds and rights as our
            Subscribers and will benefit from the same perks.
          </p>
          <p>
            DAYMADE reserves the right to amend any aspect of the Weekly Draws,
            including (but not limited to): prize table, ranges of the numbers
            draw each week (in this case, if any of the Gift Card's numbers lie
            outside the allowed range, they will be replaced by a random number
            within the correct range). Amendments made by DAYMADE will not
            invalidate any valid Gift Card and will also not result in a refund.
          </p>
          <p>
            DAYMADE Gift Cards are valid for 6 months. This means that you must
            redeem your gift card for a subscription within 6 months of its
            purchase date.
          </p>
          <p>
            In the case that DAYMADE cancels any of the Weekly Draws, the Gift
            Card’s validity will be extended accordingly where possible the make
            up for the lost draws. If this is not possible, a pro-rata refund
            will be processed for the purchaser of the Gift Card.
          </p>

          <h3>31. DAYMADE Tokens</h3>

          <p>
            Your DAYMADE Tokens expire 1 year after your most recent token was
            won or awarded. If a Token is not redeemed by the player before its
            expiry date, then it will be automatically redeemed as 1 planted
            tree.
          </p>

          <h3>32. Charity</h3>

          <p>
            For every purchase made on the Site, DAYMADE donates funds (the
            equivalent of the cost for planting one tree) to the reforestation
            organisation veritree. Each month, DAYMADE will tally the total
            number of paid purchases on the Site and transfer the appropriate
            funds to veritree (or its beneficiaries - Earth Lungs and Mother
            Trees) as a donation, such that the number of trees planted equals
            the number of purchases made on the Site.
          </p>

          <h3>33. PROMOTIONAL REWARDS</h3>

          <ol className="pl-[15px]">
            <li>
              From time to time, we may make available optional promotional
              rewards (“Promotional Rewards”) alongside our Prize Draws.
            </li>
            <li>
              Promotional Rewards are free benefits offered at our discretion.
              They are not part of the Prize Draw itself and do not affect the
              odds, outcome, or conduct of any Prize Draw.
            </li>
            <li>
              Promotional Rewards may include items such as DAYMADE Tokens, free
              entries, gift cards, discounts, or similar benefits as specified
              when the reward is presented.
            </li>
            <li>
              Unless otherwise stated, Promotional Rewards:
              <ul>
                <li>have no cash alternative,</li>
                <li>are non-transferable,</li>
                <li>
                  may have a stated expiry period after which they lapse
                  automatically, and
                </li>
                <li>
                  are limited to one per person unless expressly stated
                  otherwise.
                </li>
              </ul>
            </li>
            <li>
              We may refuse, withdraw, or cancel a Promotional Reward where we
              reasonably suspect ineligible entry, multiple accounts, or other
              abuse.
            </li>
            <li>
              We may amend, suspend, or withdraw Promotional Rewards at any
              time. This will not affect rewards already awarded.
            </li>
          </ol>

          <div className="separator" style={{ margin: '3em auto' }} />

          <p>
            All questions and concerns regarding these Terms & Conditions should
            be directed to info@daymade.co.uk.
          </p>
          <p>
            &copy; 2024 DAYMADE. All Rights Reserved. These Terms & Conditions
            may not be reprinted or republished in whole or in part without the
            prior written consent of DAYMADE.
          </p>

          <style jsx>{styles}</style>
        </div>
      </div>

      <GlowBar color="rgba(94, 254, 223, 0.35)" direction="up" height="25px" />
    </MainLayout>
  );
};

const styles = css`
  .container {
    width: 100%;
    padding-top: 20px;
    margin-bottom: 20px;
  }

  p,
  h2,
  h3,
  h4,
  h5 {
    text-align: left;
  }

  p,
  li,
  td {
    font-weight: 600;
  }

  table {
    border-collapse: collapse;
  }

  td,
  th {
    padding: 8px;
    border: 1px solid #000;
  }

  th {
    font-weight: bold;
  }

  a {
    margin: 0;
  }

  :global(.footer) {
    margin-top: 0 !important;
  }
`;

export default TermsAndConditions;
